import React from 'react';
import './auth-ui.css';

interface Props {
  title: string;
  subtitle: string;
}

const AuthLoadingOverlay: React.FC<Props> = ({ title, subtitle }) => (
  <div className="auth-overlay" role="status" aria-live="polite">
    <div className="auth-overlay-card">
      <div className="auth-overlay-spinner" aria-hidden="true" />
      <h3 className="auth-overlay-title">{title}</h3>
      <p className="auth-overlay-subtitle">{subtitle}</p>
    </div>
  </div>
);

export default AuthLoadingOverlay;
